<template>
  <div style="display: contents">
    <tr>
      <td colspan="3"></td>
      <td>
        <b-icon :icon="collapsed ? 'dash-square': 'plus-square'" variant="dark" scale="1.1" @click="collapsed = !collapsed"/>
      </td>
      <td colspan="7">
        <span class="font-weight-bold text-info">{{ item.description }}</span>
      </td>
    </tr>
    <template v-if="collapsed">
      <BookingItemResult
        v-for="(item, itemIndex) in item.items"
        :item="item"
        :booking="booking"
        :key="'pitem' + itemIndex" />
    </template>
  </div>
</template>

<script>
import BookingItemResult from './booking_item_result'

export default {
  name: 'PackageItemResult',
  props: ['item', 'booking'],
  components: { BookingItemResult },
  data () { return { collapsed: false } }
}
</script>
